import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AlertShowItemStyles";

export default class AlertShowItem extends Component {
  render() {
    const { id, assessments, level, name, text, icon } = this.props;

    return (
      <div id={`alert${id}`} className={css(styles.itemWrapper)}>
        <div className={css(styles.alert)}>
          <div
            className={css(
              styles.header,
              level === "Warning" && styles.warning,
              level === "Urgent" && styles.emergency
            )}
          >
            <span className={css(styles.headerTitle)}>
              {level === "Warning"
                ? "Investigate"
                : level === "Urgent"
                  ? "Urgent"
                  : "Message"}
            </span>
          </div>
          <div className={css(styles.body)}>
            <span className={css(styles.bodyTitle)}>
              <img className={css(styles.icon)} src={icon} alt="" />
              {name}
            </span>
            <span className={css(styles.bodyText)}>{text}</span>
          </div>
          <div
            className={css(
              assessments && assessments[0].correct
                ? styles.correctContainer
                : styles.incorrectContainer
            )}
          >
            {`Marked as ${
              assessments && assessments[0].correct ? "correct" : "incorrect"
            }`}
          </div>
        </div>
      </div>
    );
  }
}
